import React, { useState } from 'react';
import { useNavigate, useSearchParams, useLocation } from 'react-router-dom';
import {
  Card, Button, Space, Tag, Typography, Descriptions, Table, Tabs, Modal, Input, message, Image, Radio, Form, Select
} from 'antd';
import { ArrowLeftOutlined, CheckCircleOutlined, SelectOutlined } from '@ant-design/icons';

const { Title, Text } = Typography;

// TODO: 联调时替换为接口数据
const MOCK_DETAIL = {
  P_ECO_001: {
    productName: '智能云台摄像机方案', productId: 'P_ECO_001', category: '摄像机',
    vendorName: '深圳芯视界科技有限公司', vendorId: 'ENT_V01', openRange: 'public', directedEnts: [],
    auditStatus: 'pending', listTime: '2026-04-20 10:00:00', isSelf: false,
    description: '基于海思Hi3516DV300的全功能云台摄像机方案，支持1080P高清、云存储、AI人形检测、语音对讲、PTZ云台控制。适用于家庭安防、宠物看护、老人看护等场景。',
    techParams: '主控：Hi3516DV300 | 传感器：IMX307 | 分辨率：1920×1080 | 云台：水平355°/垂直90° | 存储：TF卡最大128GB | 联网：Wi-Fi 2.4GHz',
    contact: 'solution@xinshijie.com',
    images: ['/demo1.png', '/demo2.png'],
    docs: [{ name: '方案规格书.pdf', url: '#' }],
    firmwares: [
      { key: '1', fwName: '主控固件', fwVersion: 'V3.0.0', fwType: '生产固件', sdk: '30201', testStatus: 'pass', otaStatus: 'pass', finalized: true, uploadTime: '2026-04-10' },
      { key: '2', fwName: '主控固件', fwVersion: 'V3.1.0', fwType: '升级固件', sdk: '30201', testStatus: 'pass', otaStatus: 'pass', finalized: true, uploadTime: '2026-04-18' },
      { key: '3', fwName: 'WiFi模组固件', fwVersion: 'V2.1.0', fwType: '生产固件', sdk: '30201', testStatus: 'pass', otaStatus: 'pass', finalized: true, uploadTime: '2026-04-05' },
      { key: '4', fwName: '主控固件', fwVersion: 'V3.2.0-beta', fwType: '升级固件', sdk: '30201', testStatus: 'testing', otaStatus: 'wait', finalized: false, uploadTime: '2026-04-22' },
    ],
  },
};

// 选用时的目标企业（派生产品归属方）— TODO: 联调时替换为接口数据
const TARGET_ENT_OPTIONS = [
  { value: 'self', label: '本企业（方案商自身，客户未入驻平台时由方案商代管）' },
  { value: 'ENT_M01', label: '东莞康林物联网有限公司（ENT_M01）' },
  { value: 'ENT_M02', label: '成都云视科技有限公司（ENT_M02）' },
  { value: 'ENT_M03', label: '广州云联物联网有限公司（ENT_M03）' },
];

const MODEL_DATA = {
  device: {
    label: '设备能力',
    menus: ['联网方式', '对讲设置', '存储设置', '电池设置', '工作模式', '唤醒能力', 'OTA能力', '指示灯', '红外灯', '报警录制'],
    configs: {
      '联网方式': [{ label: '是否支持', type: 'radio', value: '是', options: ['是', '否'] }],
      '对讲设置': [{ label: '是否支持', type: 'radio', value: '是', options: ['是', '否'] }, { label: '对讲模式', type: 'radio', value: '全双工', options: ['全双工', '半双工'] }],
      '存储设置': [{ label: '是否支持', type: 'radio', value: '是', options: ['是', '否'] }],
      '电池设置': [{ label: '是否支持', type: 'radio', value: '否', options: ['是', '否'] }],
      '工作模式': [{ label: '是否支持', type: 'radio', value: '是', options: ['是', '否'] }],
      '唤醒能力': [{ label: '是否支持', type: 'radio', value: '否', options: ['是', '否'] }],
      'OTA能力': [{ label: '是否支持', type: 'radio', value: '是', options: ['是', '否'] }],
      '指示灯': [{ label: '是否支持', type: 'radio', value: '是', options: ['是', '否'] }],
      '红外灯': [{ label: '是否支持', type: 'radio', value: '否', options: ['是', '否'] }],
      '报警录制': [{ label: '是否支持', type: 'radio', value: '是', options: ['是', '否'] }],
    },
    stdAbilities: [
      { key: 's1', type: '属性', name: '云台控制', identifier: 'ptz_control', dataType: 'Struct', dataDef: '水平角度0-355，垂直角度0-90', desc: '', module: '云台' },
      { key: 's2', type: '属性', name: '视频流', identifier: 'video_stream', dataType: 'Enum', dataDef: '关闭/流畅/标清/高清', desc: '', module: '视频' },
      { key: 's3', type: '属性', name: '移动侦测', identifier: 'motion_detect', dataType: 'Bool', dataDef: '开/关', desc: '', module: '侦测' },
      { key: 's4', type: '属性', name: '夜视模式', identifier: 'night_vision', dataType: 'Enum', dataDef: '自动/开启/关闭', desc: '', module: '视频' },
    ],
    customAbilities: [
      { key: 'c1', type: '属性', name: '隐私遮蔽', identifier: 'privacy_mask', dataType: 'Bool', dataDef: '开/关', desc: '', module: '' },
      { key: 'c2', type: '服务', name: '巡航计划', identifier: 'cruise_plan', dataType: 'Struct', dataDef: '最多8个预置点', desc: '', module: '' },
    ],
  },
  lens: {
    label: '镜头配置',
    menus: ['分辨率', '画面翻转', '镜像'],
    configs: {
      '分辨率': [{ label: '默认分辨率', type: 'radio', value: '1080P', options: ['1080P', '2K', '4K'] }],
      '画面翻转': [{ label: '是否支持', type: 'radio', value: '是', options: ['是', '否'] }],
      '镜像': [{ label: '是否支持', type: 'radio', value: '是', options: ['是', '否'] }],
    },
    stdAbilities: [
      { key: 'ls1', type: '属性', name: '分辨率', identifier: 'resolution', dataType: 'Enum', dataDef: '1080P/2K/4K', desc: '', module: '镜头' },
      { key: 'ls2', type: '属性', name: '红外夜视', identifier: 'ir_mode', dataType: 'Enum', dataDef: '自动/开启/关闭', desc: '', module: '镜头' },
    ],
    customAbilities: [],
  },
  mic: { label: '麦克风配置', menus: ['音量设置'], configs: { '音量设置': [{ label: '默认音量', type: 'text', value: '70' }] }, stdAbilities: [], customAbilities: [] },
  screen: { label: '屏显配置', menus: ['OSD设置'], configs: { 'OSD设置': [{ label: '是否支持', type: 'radio', value: '否', options: ['是', '否'] }] }, stdAbilities: [], customAbilities: [] },
  speaker: { label: '喇叭配置', menus: ['音量设置'], configs: { '音量设置': [{ label: '默认音量', type: 'text', value: '80' }] }, stdAbilities: [], customAbilities: [] },
  capture: { label: '云端抓图', menus: ['抓图设置'], configs: { '抓图设置': [{ label: '是否支持', type: 'radio', value: '是', options: ['是', '否'] }] }, stdAbilities: [], customAbilities: [] },
};

const abilityColumns = [
  { title: '类型', dataIndex: 'type', width: 60 },
  { title: '能力名称', dataIndex: 'name', width: 120 },
  { title: '能力标识', dataIndex: 'identifier', width: 140, render: (t) => <Text code>{t}</Text> },
  { title: '数据类型', dataIndex: 'dataType', width: 80 },
  { title: '数据定义', dataIndex: 'dataDef', width: 200 },
  { title: '描述', dataIndex: 'desc', width: 100, render: (v) => v || '-' },
  { title: '所属模块', dataIndex: 'module', width: 100, render: (v) => v || '-' },
];

const EcosystemDetail = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const id = searchParams.get('id') || 'P_ECO_001';
  const auditStatus = searchParams.get('status') || '';
  const mockDetail = MOCK_DETAIL[id] || MOCK_DETAIL['P_ECO_001'];
  const detail = { ...mockDetail, ...(location.state || {}) };
  const [auditModalVisible, setAuditModalVisible] = useState(false);
  const [auditResult, setAuditResult] = useState('pass');
  const [auditForm] = Form.useForm();
  const [modelTab, setModelTab] = useState('device');
  const [modelMenu, setModelMenu] = useState('联网方式');
  const [selectModalVisible, setSelectModalVisible] = useState(false);
  const [derivedName, setDerivedName] = useState('');
  const [targetEnt, setTargetEnt] = useState('self');

  const handleSelect = () => {
    setDerivedName(`${detail.productName}-我的企业`);
    setTargetEnt('self');
    setSelectModalVisible(true);
  };

  const handleConfirmSelect = () => {
    if (!derivedName.trim()) { message.warning('请输入派生产品名称'); return; }
    const targetLabel = TARGET_ENT_OPTIONS.find((o) => o.value === targetEnt)?.label || '';
    const owner = targetEnt === 'self' ? '本企业' : targetLabel.split('（')[0];
    message.success(`选用成功，派生产品「${derivedName}」归属：${owner}`);
    setSelectModalVisible(false);
    Modal.confirm({
      title: '选用成功',
      content: `派生产品「${derivedName}」已创建（归属：${owner}），是否前往产品开发列表查看？`,
      okText: '前往查看', cancelText: '留在当前页',
      onOk: () => navigate('/product'),
    });
  };

  const handleAudit = () => {
    setAuditResult('pass');
    auditForm.resetFields();
    auditForm.setFieldsValue({ result: 'pass' });
    setAuditModalVisible(true);
  };

  const handleAuditSubmit = () => {
    auditForm.validateFields().then(values => {
      if (values.result === 'reject' && !values.reason?.trim()) { message.warning('请输入驳回原因'); return; }
      message.success(values.result === 'pass' ? '审核已通过' : '已驳回');
      setAuditModalVisible(false);
      navigate('/product/ecosystem-audit');
    });
  };

  const fwColumns = [
    { title: '固件名称', dataIndex: 'fwName', width: 140 },
    { title: '版本号', dataIndex: 'fwVersion', width: 120 },
    { title: '固件类型', dataIndex: 'fwType', width: 100, render: (v) => <Tag color={v === '生产固件' ? 'blue' : 'orange'}>{v}</Tag> },
    { title: 'SDK版本', dataIndex: 'sdk', width: 100 },
    { title: '发布时间', dataIndex: 'uploadTime', width: 120 },
  ];

  return (
    <div style={{ padding: 24 }}>
      <div style={{ marginBottom: 16, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Space><Button icon={<ArrowLeftOutlined />} onClick={() => navigate(-1)}>返回</Button><Title level={4} style={{ margin: 0 }}>方案详情</Title>
          {auditStatus && <>
            {auditStatus === 'pending' && <Tag color="processing">待审核</Tag>}
            {auditStatus === 'approved' && <Tag color="success">已通过</Tag>}
            {auditStatus === 'rejected' && <Tag color="error">已驳回</Tag>}
            <Text type="secondary" style={{ fontSize: 12 }}>审核时间：{detail.auditTime || '-'}</Text>
          </>}
        </Space>
        <Space>
          {!auditStatus && <Button type="primary" icon={<SelectOutlined />} onClick={handleSelect}>选用此方案</Button>}
          {auditStatus === 'pending' && <Button type="primary" icon={<CheckCircleOutlined />} onClick={handleAudit}>审核</Button>}
        </Space>
      </div>

      {/* 基本信息 */}
      <Card bordered={false} style={{ marginBottom: 16, borderRadius: 12 }}>
        <Descriptions bordered column={2} size="small">
          <Descriptions.Item label="方案产品">{detail.productName}</Descriptions.Item>
          <Descriptions.Item label="产品ID"><Text copyable style={{ fontFamily: 'monospace' }}>{detail.productId}</Text></Descriptions.Item>
          <Descriptions.Item label="产品类目">{detail.category}</Descriptions.Item>
          <Descriptions.Item label="方案企业">{detail.vendorName}（<Text copyable style={{ fontFamily: 'monospace', fontSize: 12 }}>{detail.vendorId}</Text>）</Descriptions.Item>
          <Descriptions.Item label="方案描述" span={2}>{detail.description}</Descriptions.Item>
          <Descriptions.Item label="联系方式">{detail.contact || '-'}</Descriptions.Item>
          <Descriptions.Item label="上架时间">{detail.listTime}</Descriptions.Item>
          <Descriptions.Item label="技术参数" span={2}>{detail.techParams || '-'}</Descriptions.Item>
          <Descriptions.Item label="方案图片" span={2}>
            {detail.images?.length > 0 ? (
              <Space>{detail.images.map((src, i) => <Image key={i} width={80} height={80} src={src} style={{ objectFit: 'cover', borderRadius: 4 }} fallback="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mN8/+F/PQAJpAN42kRrYAAAAABJRU5ErkJggg==" />)}</Space>
            ) : <Text type="secondary">-</Text>}
          </Descriptions.Item>
          <Descriptions.Item label="方案文档" span={2}>
            {detail.docs?.length > 0 ? (
              <Space>{detail.docs.map((doc, i) => <Button key={i} type="link" size="small" style={{ padding: 0 }}>{doc.name}</Button>)}</Space>
            ) : <Text type="secondary">-</Text>}
          </Descriptions.Item>
          <Descriptions.Item label="开放范围" span={2}>
            <Tag color={detail.openRange === 'public' ? 'blue' : 'orange'}>{detail.openRange === 'public' ? '公开' : '指定企业'}</Tag>
            {detail.openRange === 'directed' && detail.directedEnts?.length > 0 && (
              <div style={{ marginTop: 8 }}>
                <Text type="secondary" style={{ fontSize: 12, display: 'block', marginBottom: 4 }}>开放企业列表：</Text>
                {detail.directedEnts.map((ent, i) => (
                  <div key={i}><Text style={{ fontSize: 13 }}>{ent.name}</Text><Text type="secondary" style={{ fontSize: 12, marginLeft: 8 }}>{ent.id}</Text></div>
                ))}
              </div>
            )}
          </Descriptions.Item>
        </Descriptions>
      </Card>

      {/* 物模型能力 */}
      <Card bordered={false} style={{ marginBottom: 16, borderRadius: 12 }} title="物模型能力">
        <Tabs activeKey={modelTab} onChange={(k) => { setModelTab(k); setModelMenu(MODEL_DATA[k]?.menus?.[0] || ''); }} items={Object.entries(MODEL_DATA).map(([k, v]) => ({ key: k, label: v.label }))} />
        {MODEL_DATA[modelTab] && (
          <div style={{ display: 'flex', border: '1px solid #f0f0f0', borderRadius: 4 }}>
            {/* 左侧配置选项 */}
            <div style={{ width: 130, borderRight: '1px solid #f0f0f0', padding: '8px 0' }}>
              <div style={{ padding: '4px 12px', fontSize: 12, color: '#999' }}>配置选项</div>
              {MODEL_DATA[modelTab].menus.map(m => (
                <div key={m} onClick={() => setModelMenu(m)} style={{ padding: '8px 12px', cursor: 'pointer', fontSize: 13, background: modelMenu === m ? '#1890ff' : 'transparent', color: modelMenu === m ? '#fff' : '#333', borderLeft: modelMenu === m ? '3px solid #1890ff' : '3px solid transparent' }}>{m}</div>
              ))}
            </div>
            {/* 右侧配置内容 */}
            <div style={{ flex: 1, padding: 16 }}>
              <div style={{ borderBottom: '1px solid #f0f0f0', paddingBottom: 12, marginBottom: 16 }}>
                <Text strong>{modelMenu}配置</Text>
              </div>
              {MODEL_DATA[modelTab].configs[modelMenu]?.map((cfg, i) => (
                <div key={i} style={{ display: 'flex', alignItems: 'center', marginBottom: 12 }}>
                  <Text style={{ width: 140, color: '#595959' }}>{cfg.label}：</Text>
                  {cfg.type === 'radio' ? (
                    <Radio.Group value={cfg.value} disabled>{cfg.options.map(o => <Radio key={o} value={o}>{o}</Radio>)}</Radio.Group>
                  ) : (
                    <Text>{cfg.value}</Text>
                  )}
                </div>
              ))}
              {(!MODEL_DATA[modelTab].configs[modelMenu] || MODEL_DATA[modelTab].configs[modelMenu].length === 0) && (
                <Text type="secondary">暂无配置项</Text>
              )}
            </div>
          </div>
        )}

        {/* 标准能力 */}
        <div style={{ marginTop: 24 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
            <Title level={5} style={{ margin: 0 }}>标准能力</Title>
          </div>
          <Table columns={abilityColumns} dataSource={MODEL_DATA[modelTab]?.stdAbilities || []} rowKey="key" size="small" pagination={false} scroll={{ x: 700 }} style={{ whiteSpace: 'nowrap' }} bordered />
        </div>

        {/* 自定义能力 */}
        <div style={{ marginTop: 24 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
            <Title level={5} style={{ margin: 0 }}>自定义能力</Title>
            <Text type="secondary" style={{ fontSize: 12 }}>您所定义的每一个功能，都与固件、APP控制面板相关</Text>
          </div>
          <Table columns={abilityColumns} dataSource={MODEL_DATA[modelTab]?.customAbilities || []} rowKey="key" size="small" pagination={false} scroll={{ x: 700 }} style={{ whiteSpace: 'nowrap' }} bordered />
        </div>
      </Card>

      {/* 固件版本 */}
      <Card bordered={false} style={{ borderRadius: 12 }} title="固件版本">
        <Table columns={fwColumns} dataSource={detail.firmwares.filter(f => f.finalized)} rowKey="key" size="small" pagination={false} scroll={{ x: 600 }} style={{ whiteSpace: 'nowrap' }} />
      </Card>

      {/* 审核弹窗 */}
      <Modal title="审核方案上架申请" open={auditModalVisible} onCancel={() => setAuditModalVisible(false)} onOk={handleAuditSubmit} okText="提交审核" width={520} destroyOnClose>
        <Form form={auditForm} layout="vertical" style={{ marginTop: 16 }} initialValues={{ result: 'pass' }}>
          <div style={{ background: '#f9f9f9', padding: 12, borderRadius: 8, marginBottom: 16 }}>
            <div style={{ marginBottom: 4 }}><Text type="secondary">方案产品：</Text><Text strong>{detail.productName}</Text></div>
            <div><Text type="secondary">方案企业：</Text><Text>{detail.vendorName}（{detail.vendorId}）</Text></div>
          </div>
          <Form.Item name="result" label="审核结果" rules={[{ required: true }]}>
            <Radio.Group onChange={(e) => setAuditResult(e.target.value)}>
              <Radio value="pass">审核通过</Radio>
              <Radio value="reject">审核驳回</Radio>
            </Radio.Group>
          </Form.Item>
          {auditResult === 'reject' && (
            <Form.Item name="reason" label="驳回原因" rules={[{ required: true, message: '请输入驳回原因' }]}>
              <Input.TextArea rows={4} placeholder="请输入驳回原因" maxLength={300} showCount />
            </Form.Item>
          )}
        </Form>
      </Modal>

      {/* 选用弹窗 */}
      <Modal title="选用方案产品" open={selectModalVisible} onCancel={() => setSelectModalVisible(false)} onOk={handleConfirmSelect} okText="确认选用" width={480} destroyOnClose>
        <div style={{ marginTop: 16 }}>
          <div style={{ background: '#f9f9f9', padding: 16, borderRadius: 8, marginBottom: 16 }}>
            <div style={{ marginBottom: 8 }}><Text type="secondary">方案产品：</Text><Text strong>{detail.productName}</Text></div>
            <div><Text type="secondary">方案商：</Text><Text>{detail.vendorName}</Text></div>
          </div>
          <div style={{ marginBottom: 8 }}><Text strong>派生产品名称 <Text type="danger">*</Text></Text></div>
          <Input value={derivedName} onChange={(e) => setDerivedName(e.target.value)} placeholder="请输入派生产品名称" maxLength={50} showCount />
          <div style={{ marginTop: 16, marginBottom: 8 }}><Text strong>目标企业（派生产品归属）</Text></div>
          <Select value={targetEnt} onChange={setTargetEnt} style={{ width: '100%' }} options={TARGET_ENT_OPTIONS} />
          <Text type="secondary" style={{ fontSize: 12 }}>
            可选择客户企业；客户未入驻平台时选择「本企业」，由方案商代管产品与设备。
          </Text>
        </div>
      </Modal>
    </div>
  );
};

export default EcosystemDetail;
